/* eslint-disable @stylistic/max-len */
import { Modal } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';
import Link from 'next/link';

import { SITE_BASE_PATH } from '@/configs/site';
import { joinSgcmMsSite, joinSgcmSite } from '@/utils/url/join/public';

import { ImageWithFallback } from '../image-with-fallback';
import {
  IMAGE_HEIGHT,
  IMAGE_WIDTH,
  MODAL_TRANSITION_DURATION_MS_DEFAULT,
  NO_BROWSING_HISTORY_IMAGE,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';
import { clearBrowsingHistory, getBrowsingHistory } from './utils';

export const BrowsingHistoryModal: Component = ({
  isOpen,
  transitionDurationMs = MODAL_TRANSITION_DURATION_MS_DEFAULT,
  onClose,
}) => {
  const handleOnClose = () => {
    onClose?.();
  };

  const handleClearAllClick = () => {
    clearBrowsingHistory();
    onClose?.();
  };

  const browsingHistory = getBrowsingHistory();

  return (
    <Modal
      className={cx(
        styles.containerRoot,
        styles.isMediumModal,
      )}
      contentClassName={cx(
        styles.containerModalContent,
        styles.isCentralContent,
      )}
      isOpen={isOpen}
      title="Browsing History"
      transitionDurationMs={transitionDurationMs}
      onClose={handleOnClose}>
      { browsingHistory.length > 0
        ? (
          <>
            <button
              className={styles.link}
              onClick={handleClearAllClick}>
              Clear All
            </button>
            <div className={styles.containerBrwosingHistoryCars}>
              {browsingHistory.map(({
                id, carName, dealers, image, price, slug,
              }) => (
                <div
                  key={id}
                  className={styles.containerBrwosingHistoryCar}>
                  <Link
                    className={styles.carMakeModel}
                    href={`${joinSgcmMsSite(SITE_BASE_PATH ?? '')}/info/${id}/${slug}`}>
                    {carName}
                  </Link>
                  <div className={styles.containerCarInfo}>
                    <ImageWithFallback
                      alt="image"
                      className={styles.imageThumbnail}
                      height={IMAGE_HEIGHT}
                      src={image}
                      width={IMAGE_WIDTH} />
                    <div className={styles.containerPriceDealer}>
                      <div className={styles.price}>
                        {price}
                      </div>
                      {dealers.map(({ id: dealerId, name }) => (
                        <Link
                          key={dealerId}
                          className={styles.dealerName}
                          href={
                            dealerId === '0'
                              ? `${joinSgcmMsSite(SITE_BASE_PATH ?? '')}/info/${id}/${slug}/pricing`
                              : joinSgcmSite(`new_cars/newcars_listing.php?DID=${dealerId}`)
                          }>
                          {name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )
        : (
          <div className={styles.containerNoBrowsingCars}>
            <div className={styles.containerImage}>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: NO_BROWSING_HISTORY_IMAGE }} />
            </div>
            <div className={styles.textNoBrowCars}>You have not browsed any cars.</div>
            <Link
              className={styles.linkNewCars}
              href={joinSgcmSite('/new-cars/listing')}>
              Search New Cars
            </Link>
          </div>
        ) }
    </Modal>
  );
};
